import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'
import { Badge } from '@/components/frontend/atoms/content/Badge'
import { PostMeta } from '@/components/frontend/atoms/content/PostMeta'
import { readingMinutes } from '@/lib/utils'
import type { PublicPost } from '@/types/frontend'

interface PostHeaderProps {
  post: PublicPost
}

export const PostHeader: React.FC<PostHeaderProps> = ({ post }) => (
  <Stack gap="4">
    {post.category && <Badge tone="primary">{post.category.name}</Badge>}
    <Heading level="1">{post.title}</Heading>
    {post.excerpt && <Text size="lg" tone="secondary">{post.excerpt}</Text>}
    <PostMeta author={post.user?.name} publishedAt={post.published_at} readingMinutes={readingMinutes(post.content)} />
  </Stack>
)
